module.exports = __webpack_public_path__ + "static/img/2.cfe9f4e3.webp";